import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INVITEEIDENTIFIERS_TYPE } from '../../../../../../../constants/api';
import {
  isPersonalInviteePanelOpenSelector,
  isUploadingPersonalInviteesSelector,
  setIsPersonalInviteePanelOpen,
  uploadPersonalInvitees,
} from '../../../../../../../features/pageFeatures/createHearingPageSlice';
import { getEntityId } from '../../../../../../../features/helpers/apiHelpers';

export const useUpdatePersonalInvitees = (hearingId, invitationSource) => {
  const dispatch = useDispatch();
  const isPanelOpen = useSelector(isPersonalInviteePanelOpenSelector);
  const isUpdating = useSelector(isUploadingPersonalInviteesSelector);

  const [keys, setKeys] = useState([]);
  const [cprValue, setCprValue] = useState('');
  const [cvrValue, setCvrValue] = useState('');
  const [emailValue, setEmailValue] = useState('');

  useEffect(() => {
    if (isPanelOpen) {
      setKeys([]);
      setCprValue('');
      setCvrValue('');
      setEmailValue('');
    }
  }, [isPanelOpen]);

  function onPanelClose() {
    dispatch(setIsPersonalInviteePanelOpen(false));

    setKeys([]);
    setCprValue('');
    setCvrValue('');
    setEmailValue('');
  }

  function onAddKey() {
    const newKey = {
      attributes: {
        cpr: cprValue.trim() || undefined,
        cvr: cvrValue.trim() || undefined,
        email: emailValue.trim() || undefined,
      },
      type: INVITEEIDENTIFIERS_TYPE,
    };

    setKeys((prev) => [...prev, newKey]);

    setCprValue('');
    setCvrValue('');
    setEmailValue('');
  }

  function onRemoveKey(keyToRemove) {
    setKeys((prev) => prev.filter((key) => key !== keyToRemove));
  }

  function onSaveChanges() {
    dispatch(
      uploadPersonalInvitees({
        hearingId: hearingId,
        invitationSourceId: getEntityId(invitationSource),
        inviteeIdentifiers: keys,
      }),
    );
  }

  return {
    keys,
    cprValue,
    setCprValue,
    cvrValue,
    setCvrValue,
    emailValue,
    setEmailValue,
    isPanelOpen,
    onPanelClose,
    onAddKey,
    onRemoveKey,
    onSaveChanges,
    isUpdating,
  };
};
